<script>
import RoleEditorView from '@/views/settings/components/RoleEditorView.vue'
import { PermissionHelper } from '@/utils/NewPermissionHelper'
import { asyncRouterMap } from '@/config/router.config'

export default {
  name: 'RoleEditor2',
  components: { RoleEditorView: RoleEditorView },
  data() {
    return {
      roleId: this.$route.query.roleId,
      innerLoading: false,
      menuTree: [],
      selectKeys: [],
      activatedCount:0,
      initForm: {
        name: '',
        dataPermission: 1,
        roleId: null
      }
    }
  },
  mounted() {
    this.initBaseData()
  },
  activated() {
    if(this.activatedCount<1){
      this.activatedCount++
      return
    }
    this.initBaseData()
  },
  methods: {
    async initBaseData(){
      this.roleId=this.$route.query.roleId
      this.roleName=this.$route.query.roleName
      await this.loadBaseMenuTree()
      if(this.roleId){
        const res = await this.getRolePermissions(this.roleId)
        const { menuList,dataPermission} =res
        this.innerLoading=false
        this.initForm = {
          name: this.roleName,
          dataPermission:dataPermission,
          roleId: this.roleId?this.roleId:''
        }
        this.selectKeys=menuList
      }
    },
    /**
     * 获取店铺
     * @returns {Promise<void>}
     */
    async getMerchantMenu(){
      try {
        const url='permission/v2/selectMenusByUserId'
        const res =   await this.getHttpServices().getPermissionService().get(url)
        if(res.defaultMerchantMenuJson){
          return res.defaultMerchantMenuJson.split(',')||[]
        }
      }catch(err){
        this.$message.error(err.msg||'获取权限数据错误，请重试！')
        console.error(err)
      }

    },
    /**
     * 根据可用的路由权限ID列表筛选菜单树
     * @param {Array} allOptions 所有的菜单树（顶层分组数组）
     * @param {Array<string>} menuKeys 可用的路由权限ID列表（即路由 name 集合）
     * @returns {Array} 仅包含命中权限ID的节点及其必要的父级链
     */
    filterOptions(allOptions, menuKeys) {
      if (!allOptions || !allOptions.length) {
        return []
      }
      const keyList = menuKeys || []
      const result = []
      allOptions.forEach((item) => {
        // 1、先递归过滤子级
        const children = item.children && item.children.length
          ? this.filterOptions(item.children, keyList)
          : []
        // 2、自身命中，或子级仍有命中项 → 保留当前节点（保留父级链，避免树结构断裂）
        if (!keyList.includes(item.permissionId) && !children.length) {
          return
        }
        const copy = { ...item }
        // 原本有子级的节点同步过滤结果（可能为空数组），叶子节点保持无 children
        if (item.children && item.children.length) {
          copy.children = children
        }
        result.push(copy)
      })
      return result
    },
    // 加载基础菜单树（新建/编辑共用）
    async loadBaseMenuTree() {
      // 1、getMerchantMenu 已返回全部菜单
      const menuKeys = (await this.getMerchantMenu()) || []
      // 2、按需隐藏的菜单（商品目录 / 商户类型决定）
      const hideKeys = await this.getHideMerchantKeys()
      // 3、可用菜单 = 全部菜单 - 需隐藏的菜单
      const availableKeys = menuKeys.filter(key => !hideKeys.includes(key))
      const allOptions = PermissionHelper.getPermissionMenuOptions(asyncRouterMap[0].children, [], [])
      this.menuTree = this.filterOptions(allOptions, availableKeys)
    },

    // 初始化清空勾选
    initRecursiveClear(list) {
      list.forEach((group) => {
        group.permissionList = []
        group.checkAll = false
        const loop = (children) => {
          children.forEach((child) => {
            child.permissionList = []
            if (child.actions) {
              child.actions.forEach(act => (act.checked = false))
            }
            if (child.children) loop(child.children)
          })
        }
        loop(group.children)
      })
    },

    async getMerchantNewField() {
      const merchantId = this.$store.getters.userInfo.merchantId
      return this.getHttpServices().getUserService().post('/api/v2/merchant/getMerchantNewField/'+merchantId,{})
    },
    async getHideMerchantKeys(){
       const {productCatalogList,merchantType} = await this.getMerchantNewField();
       const hideList = []
      if(productCatalogList&&productCatalogList.length){
        if(!productCatalogList.some(item => item == 5)){
          const mList=['ConsolidationServices','AddCarriageTemplate','DepartmentSetting'];
          hideList.push(...mList);
        }
        if(productCatalogList&&productCatalogList.length==1&&productCatalogList.some(item => item == 5)){
          const mList=['DestinationList','AddDestination'];
          hideList.push(...mList);
        }
        if(!productCatalogList.some(item => item == 8)){
          const mList=['CouponCodeList','CouponOrderList','CouponProductList','CouponOrderDetail','CouponCodeDetail','CouponCodeCreator','CouponCodeEditor','CodeDetailList','CouponCodeSetting','VerificationSetting','GroupingSetting','PackagePriceSetting'];
          hideList.push(...mList);
        }
        if(!productCatalogList.some(item => item == 8||item == 5)){
          const mList=['Consignment','LogisticsUsageRecord','LogisticsPurchasing'];
          hideList.push(...mList);
        }
      }
       return hideList;
    },
    async getRolePermissions(roleId) {
      return await this.getHttpServices().getPermissionService().post('permission/v2/selectMenusByRoleId/' + roleId)
    },
    // 保存回调（子组件只抛事件，请求在本页处理）
    handleSave(payload) {
      const {permissionList,dataPermission,roleName}=payload
      const params={
        roleName,
        dataPermission,
        roleId:this.roleId,
        keyList:permissionList,
      }
      this.innerLoading = true
      this.getLogUtils().logWithTag('submitData', params)
      this.getHttpServices().getPermissionService().post('permission/v2/saveOrUpdateRole', params)
        .then(() => {
          const textStr = this.roleId ? '编辑' : '创建'
          this.$message.success(textStr + '角色成功')
          setTimeout(() => this.handleBack(), 800)
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => (this.innerLoading = false))
    },
    handleBack() {
      this.$router.back()
    }
  }
}
</script>

<template>
  <a-card>
    <RoleEditorView
      :loading="innerLoading"
      :role-id="roleId"
      :menu-tree="menuTree"
      :init-form="initForm"
      :selectedKeys="selectKeys"
      @save="handleSave"
      @back="handleBack"
    ></RoleEditorView>
  </a-card>
</template>

<style scoped lang="less">
</style>
